<div class="row" *ngFor="let announcement of Announcements">
  <div class="col">
    <div class="alert" [ngClass]="announcement.alertClass">
      <button type="button" class="close" aria-label="Close" (click)="dismissAnnouncement(announcement)">
        <span aria-hidden="true">&times;</span>
      </button>
      {{announcement.content}}
      <a *ngIf="announcement.linkType=='external'" [href]="announcement.link" target="_blank" class="btn btn-link btn-secondary btn-sm">{{announcement.linkTitle}}</a>
      <a *ngIf="announcement.linkType=='internal'" [routerLink]="announcement.link" class="btn btn-link btn-secondary btn-sm">{{announcement.linkTitle}}</a>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/announcement-bar/announcement-bar.component.html